import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex w-fit gap-3 items-center" }
const _hoisted_2 = {
  key: 2,
  class: "hidden md:flex"
}
const _hoisted_3 = {
  key: 1,
  class: "z-50"
}
const _hoisted_4 = {
  key: 0,
  ref: "speedOptions",
  class: "w-32 h-28 bg-white absolute -mt-12 ml-8 shadow-md rounded-md"
}
const _hoisted_5 = {
  key: 0,
  class: "hidden md:flex"
}
const _hoisted_6 = {
  key: 0,
  class: "hidden md:flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_motion_pop = _resolveDirective("motion-pop")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.showPlayButton)
      ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-simple flex gap-1 items-start",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.playAudio()))
        }, [
          (_ctx.audioON)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                name: "md-volumeup-round",
                scale: _ctx.scaleIcons
              }, null, 8, ["scale"]))
            : _createCommentVNode("", true),
          (!_ctx.audioON)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                name: "md-volumeoff",
                scale: _ctx.scaleIcons
              }, null, 8, ["scale"]))
            : _createCommentVNode("", true),
          (_ctx.showIconsName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.audioON ? "Áudio ligado" : "Áudio desligado"), 1))
            : _createCommentVNode("", true)
        ])), [
          [_directive_tooltip, `Desligar áudio`]
        ])
      : _createCommentVNode("", true),
    (_ctx.showSpeedButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.speedOptions)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speeds, (speed, index) => {
                  return (_openBlock(), _createBlock(_component_Button, {
                    key: index,
                    class: "w-full btn-simple h-7",
                    onClick: ($event: any) => (_ctx.speedUp(speed.value))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(speed.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ])), [
                [_directive_motion_pop]
              ])
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn-simple flex gap-2",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSpeedUpOptions && _ctx.openSpeedUpOptions(...args)))
          }, [
            _createVNode(_component_v_icon, {
              name: "md-slowmotionvideo",
              scale: _ctx.scaleIcons
            }, null, 8, ["scale"]),
            (_ctx.showIconsName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", { pt: "Repetir", en: "Repeat" })), 1))
              : _createCommentVNode("", true)
          ])), [
            [_directive_tooltip, `Velocidade: ${_ctx.getSpeedName()}`]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showRepeatButton)
      ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "btn-simple flex gap-1 items-start",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.repeatAudio()))
        }, [
          _createVNode(_component_v_icon, {
            name: "md-replay",
            scale: _ctx.scaleIcons
          }, null, 8, ["scale"]),
          (_ctx.showIconsName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", { pt: "Repetir", en: "Repeat" })), 1))
            : _createCommentVNode("", true)
        ])), [
          [_directive_tooltip, `Repetir áudio`]
        ])
      : _createCommentVNode("", true)
  ]))
}